import RemoveKeyPointButton from './ui/RemoveKeyPoint';
import RegenKeyPointButton from './ui/RegenKeyPoint';

export const KeyPoint = {
  RemoveButton: RemoveKeyPointButton,
  RegenButton: RegenKeyPointButton,
};
